import { AppEnvironment } from '~/configuration';
import type { ImageLoaderConfig, PlatformClientEnv } from '../types';

// Explicit mapping from import.meta.env → typed env. Each field documents
// where its value comes from. Shared vars use their VITE_-prefixed source
// (Vite's client-exposure convention) and are republished without the
// prefix here so server and client use the same unprefixed key.
export const env: PlatformClientEnv = {
  // --- Shared with server (VITE_-prefixed on the wire, unprefixed here) ---
  COOKIEFIRST_URL: import.meta.env.VITE_COOKIEFIRST_URL,
  AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  DASH0_RUM_ENDPOINT: import.meta.env.VITE_DASH0_RUM_ENDPOINT,
  DASH0_RUM_TOKEN: import.meta.env.VITE_DASH0_RUM_TOKEN,

  // --- Tracking (static GTM container IDs) ---
  GTM_CONTAINER_ID: import.meta.env.VITE_GTM_CONTAINER_ID,
  GTM_CONTAINER_ID_PREVIEW: import.meta.env.VITE_GTM_CONTAINER_ID_PREVIEW,

  // --- Vite built-ins ---
  DEV: import.meta.env.DEV,
};

export const imageLoader: ImageLoaderConfig = {
  fallback: 'vercel',
  options: {
    vercel: {
      baseUrl:
        AppEnvironment === 'local'
          ? 'https://image-dummy.dev.understory.io'
          : '',
    },
  },
};
